import comp from "./ArrowWithCount";
export default comp;
